import styled from 'styled-components';
import {colors} from '../../../utils/styled/_variables.styled';

export const InfiosDropdownWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;

  span {
    margin-top: 8px;
    color: ${colors.error};
  }

  select {
    color: ${props => props.selectedValue == "" ? colors.gray5 : "inherit"};
    font-weight: ${props => props.selectedValue == "" == "" ? "400" : "inherit"};
    font-size: ${props => props.selectedValue == "" ? "19px" : "inherit"};
    line-height: ${props => props.selectedValue == "" ? "100%" : "inherit"};

    &:focus ~ label, :valid ~ label {
      top: -12px;
      left: 8px;
      font-size: 10px;
      font-weight: 600;
      color: ${colors.infiosGray};
      background-color: #fff;
      padding: 0 5px 0 5px;
    }
  }


`

export const InfiosDropdown = styled.select`
  display: flex;
  height: 48px;
  width: 100%;
  padding: 12px 44px 12px 12px;
  border: 1px solid ${colors.infiosGray};
  background-color: ${colors.white};
  outline: none;
  appearance: none;
  cursor: pointer;

  & ~ label ~ span {
    display: none;
  }

  &:invalid {
    color: ${colors.gray4};
  }

  &.error ~ label ~ span {
    display: block;
  }

  option {
    color: ${colors.infiosGray};
  }

  option:disabled {
    color: ${colors.gray5};
  }

  &.error {
    border: 1px solid ${colors.error};
  }


  &:hover {
    border: 2px solid ${colors.blue};
  }

  &:focus {
    border: 2px solid ${colors.blue};
  }

  &:focus-within {
    & ~ div > svg {
      transform: rotate(180deg);

      path {
        fill: ${colors.blue};
      }
    }
  }

  &:disabled {
    background-color: ${colors.gray1};
    border: 1px solid ${colors.gray1};
    pointer-events: none;
  }
`

export const InfiosArrowWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 25px;
  right: 18px;
  transform: translateY(-50%);
  cursor: pointer;
  z-index: 1;

  svg {
    pointer-events: none;

    path {
      fill: ${props => props.disabled ? colors.gray4 : colors.infiosGray};
    }
  }

  &.menu-open {
    & svg {
      transform: rotate(180deg);

      path {
        fill: ${colors.blue};
      }
    }
  }
`;

export const InfiosOption = styled.option`
  font-size: 1rem;
  color: ${colors.infiosGray};

  &:disabled {
    color: ${colors.gray3};
  }
`;
